<div class="db-payment-management" *ngIf="!['domain-payouts', 'payouts'].includes(pageId)">
  <div class="db-payment-management__header">
    <h1>{{ 'text_paymentManagement' | dbText }}</h1>
    <p class="mt4">{{ 'text_monitorYourPayoutsAndPaymentStatus' | dbText }}</p>
  </div>

  <div class="db-payment-management__content mt30">
    <div class="db-payment-management__table">
      <!-- Header Row -->
      <div class="db-payment-management__row db-payment-management__header-row">
        <div class="db-payment-management__cell">{{ 'text_website' | dbText }}</div>
        <div class="db-payment-management__cell">{{ 'text_email' | dbText }}</div>
        <div class="db-payment-management__cell">{{ 'text_stripeAccountId' | dbText }}</div>
        <div class="db-payment-management__cell">{{ 'text_status' | dbText }}</div>
        <div class="db-payment-management__cell">{{ 'text_actions' | dbText }}</div>
      </div>
      <div class="db-payment-management__row db-payment-management__list empty" *ngIf="!merchantsList?.length">
        <p class="no-payments">{{ 'text_youDontHaveAnyPayments' | dbText }}</p>
      </div>

      <ng-container *ngFor="let merchant of merchantsList">
        <div class="db-payment-management__row db-payment-management__list">
          <div class="db-payment-management__cell siteUrl">
            <a class="ds-link" [routerLink]="'../websites/' + merchant?.websiteId + '/ecommerce/payment-methods'" *ngIf="!!merchant?.websiteId">
              <span [innerHTML]="merchant?.siteUrl"></span>
            </a>
            <span [innerHTML]="merchant?.siteUrl" *ngIf="!merchant?.websiteId"></span>
          </div>
          <div class="db-payment-management__cell email">{{merchant?.email}}</div>
          <div class="db-payment-management__cell">{{merchant?.merchantId}}</div>
          <div class="db-payment-management__cell">
            <i
               [className]="'db-icon db-icon-ds-dot mr3 ' + merchant?.merchantStatus"></i>
            <span>{{merchant?.merchantStatus | replaceWithSpaces}}</span>
          </div>
          <div class="db-payment-management__cell">
            <a class="view-payouts"
               [ngClass]="{'active': merchant?.merchantStatus === 'complete', 'disabled': merchant?.merchantStatus !== 'complete'}"
               [routerLink]="['/payments-management/' + merchant?.websiteId + '/payouts']" *ngIf="!!merchant?.websiteId">{{ 'text_viewPayouts' | dbText }}</a>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<router-outlet *ngIf="['domain-payouts', 'payouts'].includes(pageId)"></router-outlet>

